<div class="wrapper-cards" *ngIf="isResellers && resellersGold.length > 0">
  <div class="card card-client"
  *ngFor="let reseller of resellersGold">

    <div
    class="card-header reseller-gold"
    >
    <img
    src="../../../../assets/icons/cliente-ouro.png"
    style="width: 36px"
    />
    <span class="title-reseller-gold" #tooltip="matTooltip"
    matTooltip="{{reseller.apeCli}}"
    (mouseover)="tooltip.hide()"

      (click)="tooltip.toggle()"
      style="cursor: pointer"
>
        {{ reseller.apeCli}}
      </span>
    </div>

    <div class="card-body text-start">
      <h5 class="card-title">
        {{ reseller.nomCli }}
      </h5>
      <p>{{ reseller.endCli + " " + reseller.nenCli + " " + reseller.baiCli + " " + reseller.cplEnd }}</p>

      <div class="container d-flex" style="--bs-gutter-x: -2rem">
        <div class="image-fone">
          <img
            src="../../../../assets/icons/fone_icon.svg"
            style="width: 20px; height: 25px"
          />
        </div>
        <div class="paragraph" style="margin-left: -1rem">
          <span style="margin-left: 20px">{{ reseller.fonCli }}</span>
        </div>
      </div>
      <p>{{ reseller.cidCli }} - {{ reseller.sigUfs }}</p>
      <p class="text-lowercase">{{ reseller.emaCom }}</p>
    </div>
  </div>
</div>
<div class="wrapper-cards" *ngIf="isResellers && resellers.length > 0" >

  <div
    class="card  card-client reseller"
    *ngFor="let reseller of resellers "
  >
    <div
      class="card-header reseller"
    >
      <span class="alturaLinha" #tooltip="matTooltip"
      matTooltip="{{reseller.apeCli}}"
      (click)="tooltip.toggle()"
      style="cursor: pointer"
>
        {{ reseller.apeCli }}
      </span>
    </div>

    <div
      class="card-body"
    >
      <h5 class="card-title alturaLinha">
        {{ reseller.nomCli }}
      </h5>
      <p class="alturaLinha">{{ reseller.endCli + " " + reseller.nenCli + " " + reseller.baiCli + " " + reseller.cplEnd }}</p>

      <div class="container d-flex" style="--bs-gutter-x: -2rem">
        <div class="image-fone">
          <img
            src="../../../../assets/icons/fone_icon.svg"
            style="width: 20px; height: 25px"
          />
        </div>
        <div class="paragraph" style="margin-left: -1rem">
          <span style="margin-left: 2em">{{ reseller.fonCli }}</span>
        </div>
      </div>
      <p>{{ reseller.cidCli }} - {{ reseller.sigUfs }}</p>
      <p class="text-lowercase alturaLinha">{{ reseller.emaCom }}</p>
    </div>
    </div>
</div>


<div class="wrapper-cards" *ngIf="!isResellers && allAssistances.length > 0">
  <div
      class="card card-client bg-light"

      *ngFor="let assistance of allAssistances"
    >
    <div class="card-header assistance">
        <img
          src="../../../../assets/icons/assistencia_icon.svg"
          style="width: 46px; height: 46px"
        />
        <span #tooltip="matTooltip"
        matTooltip="{{assistance.apeCli}}"
        matTooltipPosition="above"
        (click)="tooltip.toggle()"
        style="cursor: pointer"

>{{ assistance.apeCli }}</span>
    </div>
      <div class="card-body text-start">
        <h5 class="card-title">
          {{ assistance.nomCli }}
        </h5>
        <p>{{ assistance.endCli + " " + assistance.nenCli + " " + assistance.baiCli + " " + assistance.cplEnd }}</p>

        <div class="container d-flex" style="--bs-gutter-x: -2rem">
          <div class="image-fone">
            <img
              src="../../../../assets/icons/fone_icon.svg"
              style="width: 20px; height: 25px"
            />
          </div>
          <div class="paragraph" style="margin-left: -1rem">
            <span style="margin-left: 20px">{{ assistance.fonCli }}</span>
          </div>
        </div>
        <p>{{ assistance.cidCli }} - {{ assistance.sigUfs }}</p>
        <p class="text-lowercase">{{ assistance.emaCom }}</p>
      </div>
  </div>
</div>

